import React from 'react';
import {
    Box,
    Typography,
    Paper,
    ToggleButton,
    ToggleButtonGroup,
    Button
} from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
import PropTypes from 'prop-types';

const TaskAnswerViewer = ({ 
    taskContent, 
    answerContent, 
    onSolveProblem,
    solveProblemUrl
}) => {
    const [contentView, setContentView] = React.useState('task');

    return (
        <Paper 
            elevation={2} 
            sx={{ 
                p: 3, 
                mb: 3,
                border: '2px solid',
                borderColor: 'primary.main',
                borderRadius: 2
            }}
        >
            <Box sx={{ mb: 2 }}>
                <ToggleButtonGroup
                    value={contentView}
                    exclusive
                    onChange={(e, newValue) => newValue && setContentView(newValue)}
                    aria-label="content view"
                    fullWidth
                >
                    <ToggleButton value="task" aria-label="task">
                        Task
                    </ToggleButton>
                    <ToggleButton value="answer" aria-label="answer">
                        Answer
                    </ToggleButton>
                </ToggleButtonGroup>
            </Box>

            {/* Task or Answer Content */}
            <Box sx={{ minHeight: '200px' }}>
                {contentView === 'task' ? (
                    taskContent || (
                        <Typography color="text.secondary">
                            Task content not available.
                        </Typography>
                    )
                ) : (
                    answerContent || (
                        <Typography color="text.secondary">
                            Answer not available.
                        </Typography>
                    )
                )}
            </Box>

            {/* Action Buttons Below Task */}
            {solveProblemUrl && (
                <Box sx={{ display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap' }}>
                    <Button
                        variant="contained"
                        color="primary"
                        startIcon={<OpenInNew />}
                        onClick={() => {
                            if (onSolveProblem) {
                                onSolveProblem(solveProblemUrl);
                            } else {
                                window.open(solveProblemUrl, '_blank');
                            }
                        }}
                    >
                        Solve the Problem
                    </Button>
                </Box>
            )}
        </Paper>
    );
};

TaskAnswerViewer.propTypes = {
    taskContent: PropTypes.node,
    answerContent: PropTypes.node,
    onSolveProblem: PropTypes.func,
    solveProblemUrl: PropTypes.string
};

export default TaskAnswerViewer;
